'use client';

import { useState, useEffect } from 'react';
import useDevice from '@/hooks/useDevice';
import "@/styles/sections/sections.scss";
import { Button } from '@/components/ui/Button/Button';
import Image from 'next/image';
import { useLanguage } from '@/context/LanguageContext';
const StepInfoSection = () => {
    const [phase, setPhase] = useState(1);
    const { isMobile } = useDevice();
    const { t } = useLanguage();
    useEffect(() => {
        const timer = setInterval(() => {
            setPhase((currentPhase) => {
                return currentPhase >= 3 ? 1 : currentPhase + 1;
            });
        }, 2000); // 2초마다 실행

        return () => clearInterval(timer);
    }, []);

    // 각 스텝이 활성화되어야 하는지 확인하는 함수
    const isStepActive = (stepNumber: number) => {
        return stepNumber <= phase;
    };

    // 현재 채워지고 있는 라인의 인덱스
    const getActiveLineIndex = () => {
        if (phase === 1) return 1; // Step 1일 때: 첫 번째 선이 채워짐
        if (phase === 2) return 2; // Step 2일 때: 두 번째 선이 채워짐
        return 0; // Step 3일 때: 채워지는 선 없음
    };

    // 선이 이미 완료되었는지 확인
    const isLineCompleted = (lineNumber: number) => {
        if (lineNumber === 1) {
            // 첫 번째 선: phase가 2 이상이면 완료 (현재 채워지는 중 제외)
            return phase >= 1 && getActiveLineIndex() !== 1;
        }
        if (lineNumber === 2) {
            // 두 번째 선: phase가 3 이상이면 완료 (현재 채워지는 중 제외)
            return phase >= 2 && getActiveLineIndex() !== 2;
        }
        return false;
    };

    return (
        <div className="stepinfo-section">
            <p className="title">{t.stepinfo.title}</p>
            <div className="body-container">
                <div className='step-container'>
                    <Button
                        type='tertiary-black'
                        label='Step 1'
                        otherClassName={`btn-radius-100 width-100p ${isStepActive(1) ? 'active' : ''}`}
                        icon='none'
                        size={isMobile ? 'medium' : 'large'}
                    />
                    <div
                        className={`step-line ${isLineCompleted(1) ? 'completed' : ''} ${getActiveLineIndex() === 1 ? 'filling' : ''}`}
                    ></div>
                    <Button
                        type='tertiary-black'
                        label='Step 2'
                        otherClassName={`btn-radius-100 width-100p ${isStepActive(2) ? 'active' : ''}`}
                        icon='none'
                        size={isMobile ? 'medium' : 'large'}
                    />
                    <div
                        className={`step-line ${isLineCompleted(2) ? 'completed' : ''} ${getActiveLineIndex() === 2 ? 'filling' : ''}`}
                    ></div>
                    <Button
                        type='tertiary-black'
                        label='Step 3'
                        otherClassName={`btn-radius-100 width-100p ${isStepActive(3) ? 'active' : ''}`}
                        icon='none'
                        size={isMobile ? 'medium' : 'large'}
                    />
                </div>
                {phase === 1 && (
                    <div className='step-detail-container'>
                        <div className='headline'>
                            <p className='title'>{t.stepinfo.step1.title}</p>
                            <p className='description'>{t.stepinfo.step1.description}</p>
                        </div>
                        <div className='image-container'>
                            <Image
                                src="/images/steps/step-1.png"
                                alt="step1"
                                width={564}
                                height={564}
                            />
                        </div>
                    </div>

                )}
                {phase === 2 && (
                    <div className='step-detail-container'>
                        <div className='headline'>
                            <p className='title'>{t.stepinfo.step2.title}</p>
                            <p className='description'>{t.stepinfo.step2.description}</p>
                        </div>
                        <div className='image-container step2'>
                            <Image
                                src="/images/steps/step-2.png"
                                alt="step2"
                                width={564}
                                height={564}
                            />
                        </div>
                    </div>
                )}
                {phase === 3 && (
                    <div className='step-detail-container'>
                        <div className='headline'>
                            <p className='title'>{t.stepinfo.step3.title}</p>
                            <p className='description'>{t.stepinfo.step3.description}</p>
                        </div>
                        <div className='image-container-full'>
                            <Image
                                src="/images/steps/step-3.png"
                                alt="step3"
                                width={564}
                                height={564}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StepInfoSection;